module.exports = __webpack_public_path__ + "img/racetrack-mauritius-turf.d512ba9a.svg";